export default class JSONResultMiddleware {

}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/json-result.js